import React from "react";

function RemoveUser() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1559_1281)">
        <path
          d="M12.1 11.37C12 11.36 11.88 11.36 11.77 11.37C9.39 11.29 7.5 9.34 7.5 6.94C7.5 4.54 9.48 2.5 11.94 2.5C14.4 2.5 16.38 4.49 16.38 6.94C16.37 9.34 14.48 11.29 12.1 11.37Z"
          stroke="#424242"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.24 15.9301C14.83 14.0201 9.2 14.0201 5.75999 15.9301C2.74 17.6201 2.74 20.3801 5.75999 22.0601C8.01999 23.3201 11.22 23.7601 14.12 23.3601"
          stroke="#424242"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.25 18.4102L21.91 23.0702"
          stroke="#424242"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.91 18.4102L17.25 23.0702"
          stroke="#424242"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1559_1281">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default RemoveUser;
